import React from 'react';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import { CylinderOption } from './cylinder-option/cylinder-option';
import { CylinderSectionProps } from './types/CylinderSectionProps';

export function CylinderSection({
  sectionHeading,
  availableCylinders,
  setSelectedCylinder,
  selectedCylinder,
}: Readonly<CylinderSectionProps>) {
  return (
    <div>
      {sectionHeading && <RichTextRenderer className="text-xl" blocks={sectionHeading} />}
      <div className="mt-3 flex gap-4">
        {availableCylinders?.map((cylinder) => (
          <CylinderOption
            key={cylinder.type}
            cylinder={cylinder}
            isSelected={selectedCylinder?.type === cylinder.type}
            onSelect={() => setSelectedCylinder(cylinder)}
          />
        ))}
      </div>
    </div>
  );
}
